import React from 'react';

import Dropdown from '../Dropdown';

const Selected = ({ count, children }) => {

  const Choices = () => {
    return <span>{ i18n.t('import_rss.selected') } <span className="count">{count}</span></span>;
  }

  return (<>
    <Dropdown name={Choices}>
      {children}
    </Dropdown>
  </>);
}

export default Selected;
